import { __decorate } from "tslib";
import fetchFromCache from '@/utilities/fetchFromCache';
import { Module, VuexModule, MutationAction } from 'vuex-module-decorators';
let StarshipEquipment = class StarshipEquipment extends VuexModule {
    constructor() {
        super(...arguments);
        this.starshipEquipment = [];
        this.cachedVersion = 0;
    }
    async fetchStarshipEquipment() {
        const { data: starshipEquipment, cachedVersion } = await fetchFromCache(this, 'starshipEquipment', 'starshipEquipment');
        return { starshipEquipment, cachedVersion };
    }
};
__decorate([
    MutationAction({ mutate: ['starshipEquipment', 'cachedVersion'] })
], StarshipEquipment.prototype, "fetchStarshipEquipment", null);
StarshipEquipment = __decorate([
    Module({ namespaced: true, name: 'starshipEquipment' })
], StarshipEquipment);
export default StarshipEquipment;
